"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const functionNameRegExp = /[#A-Za-z]/;
exports.default = functionNameRegExp;
